/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./js/sections/3d-scroll-wheel-animation.js":
/*!**************************************************!*\
  !*** ./js/sections/3d-scroll-wheel-animation.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! three */ "./node_modules/three/build/three.module.js");
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! gsap */ "./node_modules/gsap/index.js");
/* harmony import */ var gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! gsap/ScrollTrigger */ "./node_modules/gsap/ScrollTrigger.js");
/* harmony import */ var svelte_easing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/easing */ "./node_modules/svelte/src/runtime/easing/index.js");
/* harmony import */ var three_addons_loaders_SVGLoader_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! three/addons/loaders/SVGLoader.js */ "./node_modules/three/examples/jsm/loaders/SVGLoader.js");
/* harmony import */ var JsComponents_breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! JsComponents/breakpoints */ "./js/components/breakpoints.js");
/* harmony import */ var JsComponents_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! JsComponents/constants */ "./js/components/constants.js");







const svgLoader = new three_addons_loaders_SVGLoader_js__WEBPACK_IMPORTED_MODULE_1__.SVGLoader();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  const canvas = document.getElementById("homepage-banner");
  const currentBreakPoint = (0,JsComponents_breakpoints__WEBPACK_IMPORTED_MODULE_2__["default"])();
  if (!canvas) return;

  //canvas config
  let height = 250;
  if (currentBreakPoint >= JsComponents_constants__WEBPACK_IMPORTED_MODULE_3__.TABLET_BREAKPOINT) {
    height = 400;
  }
  if (currentBreakPoint >= JsComponents_constants__WEBPACK_IMPORTED_MODULE_3__.DESKTOP_BREAKPOINT) {
    height = 500;
  }
  if (currentBreakPoint >= JsComponents_constants__WEBPACK_IMPORTED_MODULE_3__.DESKTOP_BREAKPOINT_MEDIUM) {
    height = 600;
  }
  if (currentBreakPoint >= JsComponents_constants__WEBPACK_IMPORTED_MODULE_3__.DESKTOP_BREAKPOINT_LARGE) {
    height = 800;
  }
  if (currentBreakPoint >= JsComponents_constants__WEBPACK_IMPORTED_MODULE_3__.DESKTOP_BREAKPOINT_EXTRA_LARGE) {
    height = 1500;
  }
  let focalPoint = 6; //determine zoom position
  const width = window.innerWidth;
  if (currentBreakPoint >= JsComponents_constants__WEBPACK_IMPORTED_MODULE_3__.TABLET_BREAKPOINT) {
    focalPoint = 8;
  }
  if (currentBreakPoint >= JsComponents_constants__WEBPACK_IMPORTED_MODULE_3__.DESKTOP_BREAKPOINT) {
    focalPoint = 7;
  }

  //texture
  const topLevelTextures = window.snsHealth["homepage"]?.smallImages;
  const baseLevelTextures = window.snsHealth["homepage"]?.bigImages;
  if (!topLevelTextures && !baseLevelTextures) {
    return;
  }
  const scene = new three__WEBPACK_IMPORTED_MODULE_4__.Scene();
  const camera = new three__WEBPACK_IMPORTED_MODULE_4__.PerspectiveCamera(focalPoint, window.innerWidth / height, 100, 10000);
  const renderer = new three__WEBPACK_IMPORTED_MODULE_4__.WebGLRenderer({
    canvas: document.getElementById("homepage-banner"),
    antialias: true,
    alpha: true
  });
  let bigIconMesh = new three__WEBPACK_IMPORTED_MODULE_4__.Object3D();
  svgLoader.load(
  // resource URL
  'https://cdn.shopify.com/s/files/1/0650/5765/2967/files/final-svg.svg?v=1702548792',
  // called when the resource is loaded
  function (data) {
    const paths = data.paths;
    const texture = loader.load("https://cdn.shopify.com/s/files/1/0650/5765/2967/files/texture.jpg?v=1703316157");
    texture.wrapS = texture.wrapT = three__WEBPACK_IMPORTED_MODULE_4__.RepeatWrapping;
    texture.repeat.set(1, 1);
    for (let i = 0; i < paths.length; i++) {
      const path = paths[i];
      const material = new three__WEBPACK_IMPORTED_MODULE_4__.MeshPhongMaterial({
        map: texture
      });
      const shapes = three_addons_loaders_SVGLoader_js__WEBPACK_IMPORTED_MODULE_1__.SVGLoader.createShapes(path);
      const extrudeSettings = {
        depth: 120,
        steps: 1,
        bevelEnabled: true,
        bevelThickness: 1,
        bevelSize: 1,
        bevelOffset: 0,
        bevelSegments: 1
      };
      for (let j = 0; j < shapes.length; j++) {
        const shape = shapes[j];
        const geometry = new three__WEBPACK_IMPORTED_MODULE_4__.ExtrudeGeometry(shape, extrudeSettings);
        const mesh = new three__WEBPACK_IMPORTED_MODULE_4__.Mesh(geometry, material);
        bigIconMesh.add(mesh);
      }
    }
    let light = new three__WEBPACK_IMPORTED_MODULE_4__.DirectionalLight('#fff');
    light.position.set(-150, -80, 200);
    light.castShadow = true;
    light.shadowDarkness = 1;
    light.intensity = 20;
    scene.add(light);
    let d = bigIconMesh.scale.set(1.5, -1.8, 2);
    if (currentBreakPoint >= JsComponents_constants__WEBPACK_IMPORTED_MODULE_3__.TABLET_BREAKPOINT) {
      bigIconMesh.scale.set(2, -1.8, 2);
    }
    bigIconMesh.position.set(-200, 150, 0);
    scene.add(bigIconMesh);
  });
  renderer.setSize(width, height);
  camera.aspect = window.innerWidth / height;
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setClearColor(0xffffff, 0);
  camera.position.z = 4000;
  //main group
  const planeGroups = new three__WEBPACK_IMPORTED_MODULE_4__.Group();
  //top level plane Group
  const topLevelPlanes = new three__WEBPACK_IMPORTED_MODULE_4__.Group();
  //sublevel planes
  const subLevelPlanes = new three__WEBPACK_IMPORTED_MODULE_4__.Group();
  //sublevel planes
  const baseLevelPlanes = new three__WEBPACK_IMPORTED_MODULE_4__.Group();
  var lookAt = new three__WEBPACK_IMPORTED_MODULE_4__.Vector3();
  var lookAtScale = new three__WEBPACK_IMPORTED_MODULE_4__.Vector3(1.1, 1, 1.1);
  var itemH = 180;
  const loader = new three__WEBPACK_IMPORTED_MODULE_4__.TextureLoader();
  let originalTopLevelTexturesIndex = 0;
  //top level
  for (let i = 0; i < 20; i += 5) {
    let itemsPerRound = 4;
    let mainRadius = 500;
    let rounds = Math.ceil(30 / 5 / itemsPerRound);
    let sectorStep = Math.PI * 2 / itemsPerRound;
    let ii = i / 5;
    let round = Math.floor(ii / itemsPerRound);
    let sector = ii % itemsPerRound * sectorStep;
    const geometry = new three__WEBPACK_IMPORTED_MODULE_4__.PlaneGeometry(80, 80, 80);
    const texture = loader.load(topLevelTextures[originalTopLevelTexturesIndex]?.src ? topLevelTextures[originalTopLevelTexturesIndex].src : topLevelTextures[originalTopLevelTexturesIndex]);
    const material = new three__WEBPACK_IMPORTED_MODULE_4__.MeshBasicMaterial({
      map: texture,
      side: three__WEBPACK_IMPORTED_MODULE_4__.DoubleSide
    });
    const singlePlaneGroup = new three__WEBPACK_IMPORTED_MODULE_4__.Mesh(geometry, material);
    let h = itemH * round - itemH * (rounds * Math.random() * (0.1 - 0.2) + 0.1);
    singlePlaneGroup.position.setFromCylindricalCoords(mainRadius, sector, h);
    lookAt.copy(singlePlaneGroup.position);
    lookAt.multiply(lookAtScale);
    singlePlaneGroup.lookAt(lookAt);
    topLevelPlanes.add(singlePlaneGroup);
    originalTopLevelTexturesIndex += 1;
  }

  //base level
  let originalBaseLevelTexturesIndex = 0;
  for (let i = 0; i < 21; i += 3) {
    let itemsPerRound = 4;
    let mainRadius = 450;
    let rounds = Math.ceil(30 / 5 / itemsPerRound);
    let sectorStep = Math.PI * 2 / itemsPerRound;
    let ii = i / 5;
    let round = Math.floor(ii / itemsPerRound);
    let sector = ii % itemsPerRound * sectorStep;
    const singlePlaneGroup = new three__WEBPACK_IMPORTED_MODULE_4__.Group();
    const texture = loader.load(baseLevelTextures[originalBaseLevelTexturesIndex]?.src ? baseLevelTextures[originalBaseLevelTexturesIndex].src : baseLevelTextures[originalBaseLevelTexturesIndex]);
    const geometry = new three__WEBPACK_IMPORTED_MODULE_4__.PlaneGeometry(250, 170);
    const materialFront = new three__WEBPACK_IMPORTED_MODULE_4__.MeshBasicMaterial({
      map: texture,
      side: three__WEBPACK_IMPORTED_MODULE_4__.FrontSide
    });
    const materialBack = new three__WEBPACK_IMPORTED_MODULE_4__.MeshBasicMaterial({
      map: texture,
      side: three__WEBPACK_IMPORTED_MODULE_4__.BackSide,
      transparent: true,
      opacity: 0.3
    });
    const planeFront = new three__WEBPACK_IMPORTED_MODULE_4__.Mesh(geometry, materialFront);
    const planeBack = new three__WEBPACK_IMPORTED_MODULE_4__.Mesh(geometry, materialBack);
    singlePlaneGroup.add(planeFront);
    singlePlaneGroup.add(planeBack);
    let h = itemH * round - itemH * (rounds * Math.random() * (0.3 - 0.1) + 0.1);
    singlePlaneGroup.position.setFromCylindricalCoords(mainRadius, sector, h);
    lookAt.copy(singlePlaneGroup.position);
    lookAt.multiply(lookAtScale);
    singlePlaneGroup.lookAt(lookAt);
    baseLevelPlanes.add(singlePlaneGroup);
    originalBaseLevelTexturesIndex += 1;
  }
  planeGroups.add(topLevelPlanes);
  planeGroups.add(subLevelPlanes);
  planeGroups.add(baseLevelPlanes);
  planeGroups.rotateX(-0.2);
  camera.rotateZ(0.2);
  scene.add(planeGroups);
  const parent = document.querySelector('.main-banner');
  gsap__WEBPACK_IMPORTED_MODULE_5__["default"].registerPlugin(gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_6__["default"]);
  const timeLine = gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_6__["default"].create({
    trigger: parent,
    start: "-20% top",
    markers: false,
    preventOverlaps: false,
    onUpdate: self => {
      gsap__WEBPACK_IMPORTED_MODULE_5__["default"].timeline().to(planeGroups.rotation, {
        y: "-=4",
        duration: 12
      }).to(gsap__WEBPACK_IMPORTED_MODULE_5__["default"].to(planeGroups.rotation, {
        y: "-=4",
        duration: 60
      }));
    }
  });
  window.addEventListener('resize', onWindowResize, false);
  let mouseY = 0;
  parent.addEventListener("mousemove", ev => {
    const upMovement = gsap__WEBPACK_IMPORTED_MODULE_5__["default"].to(bigIconMesh.rotation, {
      y: "0.05",
      duration: 1
    });
    const downMovement = gsap__WEBPACK_IMPORTED_MODULE_5__["default"].to(bigIconMesh.rotation, {
      y: "-0.05",
      duration: 1
    });
    if (ev.pageY < mouseY) {
      downMovement.pause();
      upMovement.play();
    } else if (ev.pageY > mouseY) {
      upMovement.pause();
      downMovement.play();
    }
    mouseY = ev.pageY;
  });

  // window.addEventListener('scroll', onScroll, false);
  function onWindowResize() {
    camera.aspect = window.innerWidth / height;
    renderer.setSize(window.innerWidth, height);
    renderer.setPixelRatio(window.devicePixelRatio);
    camera.updateProjectionMatrix();
  }
  function animate() {
    requestAnimationFrame(animate);
    renderer.render(scene, camera);
  }
  animate();
});

/***/ }),

/***/ "./js/sections/bundle-section.js":
/*!***************************************!*\
  !*** ./js/sections/bundle-section.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var JsComponents_svelte_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! JsComponents/svelte-wrapper */ "./js/components/svelte-wrapper.js");
/* harmony import */ var SvelteComponents_add_to_cart_bundle_svelte__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! SvelteComponents/add-to-cart-bundle.svelte */ "./js/components/svelte/add-to-cart-bundle.svelte");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  (0,JsComponents_svelte_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"])(SvelteComponents_add_to_cart_bundle_svelte__WEBPACK_IMPORTED_MODULE_1__["default"], 'add-to-cart-bundle', '#product-data');
});

/***/ }),

/***/ "./js/sections/collectionBanner.js":
/*!*****************************************!*\
  !*** ./js/sections/collectionBanner.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! gsap */ "./node_modules/gsap/index.js");
/* harmony import */ var gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! gsap/ScrollTrigger */ "./node_modules/gsap/ScrollTrigger.js");
/* harmony import */ var JsComponents_breakpoints__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! JsComponents/breakpoints */ "./js/components/breakpoints.js");



const parallaxParent = document.querySelector("[data-collection-parallax-parent]");
const parallaxEffect = () => {
  const currentBreakPoint = (0,JsComponents_breakpoints__WEBPACK_IMPORTED_MODULE_0__["default"])();
  const desktopParent = parallaxParent.querySelector('[data-desktop-parent]');
  const mobileParent = parallaxParent.querySelector('[data-mobile-parent]');
  gsap__WEBPACK_IMPORTED_MODULE_1__["default"].registerPlugin(gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_2__["default"]);
  const collectionBannerTimeline = gsap__WEBPACK_IMPORTED_MODULE_1__["default"].timeline({
    scrollTrigger: {
      trigger: parallaxParent,
      start: "-20% top",
      end: () => `+=${parallaxParent.offsetHeight}`,
      markers: false,
      ease: "none",
      scrub: 2
    }
  });
  if (currentBreakPoint >= 767) {
    const parallaxItems = desktopParent.querySelectorAll("[data-collection-parallax-image]");
    const parallaxContentFirst = parallaxItems[0];
    const parallaxContentSecond = parallaxItems[1];
    const parallaxContentThird = parallaxItems[2];
    const parallaxContentFourth = parallaxItems[3];
    //start the animation
    collectionBannerTimeline.add('start');
    collectionBannerTimeline.to(parallaxContentFirst, {
      y: "50",
      duration: 12
    }, 'start');
    collectionBannerTimeline.to(parallaxContentSecond, {
      y: "-100",
      x: "-40",
      rotation: -4,
      transformOrigin: "top left",
      duration: 20
    }, 'start');
    collectionBannerTimeline.to(parallaxContentThird, {
      y: "-100",
      x: "40",
      rotation: 6,
      transformOrigin: "top right",
      duration: 20
    }, 'start');
    collectionBannerTimeline.to(parallaxContentFourth, {
      y: "50",
      duration: 12
    }, 'start');
  } else {
    const parallaxItems = mobileParent.querySelectorAll("[data-collection-parallax-image]");
    const parallaxContentFirst = parallaxItems[0];
    const parallaxContentSecond = parallaxItems[1];
    //start the animation
    collectionBannerTimeline.add('start');
    collectionBannerTimeline.to(parallaxContentFirst, {
      y: "-70",
      x: "-20",
      duration: 20
    }, 'start');
    collectionBannerTimeline.to(parallaxContentSecond, {
      y: "-70",
      x: "20",
      rotation: 6,
      transformOrigin: "top right",
      duration: 20
    }, 'start');
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  if (!parallaxParent) return;
  parallaxEffect();
});

/***/ }),

/***/ "./js/sections/countdown-timer.js":
/*!****************************************!*\
  !*** ./js/sections/countdown-timer.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  const block = document.querySelector('[data-minute]');
  if (!block) {
    console.error("Block element not found. [ endDate - timer ]");
    return;
  }
  const minuteValue = parseInt(block.dataset?.minute);
  const hourValue = parseInt(block.dataset?.hour);
  const dayValue = parseInt(block.dataset?.day);
  const yearValue = parseInt(block.dataset?.year);
  const blockStart = document.querySelector('[data-start-timer]');
  if (!blockStart) {
    console.error("Block element not found.");
    return;
  }
  const minuteValueStart = parseInt(blockStart.dataset?.minuteStart);
  const hourValueStart = parseInt(blockStart.dataset?.hourStart);
  const dayValueStart = parseInt(blockStart.dataset?.dayStart);
  const yearValueStart = parseInt(blockStart.dataset?.yearStart);
  const monthMap = {
    january: 1,
    february: 2,
    march: 3,
    april: 4,
    may: 5,
    june: 6,
    july: 7,
    august: 8,
    september: 9,
    october: 10,
    november: 11,
    december: 12
  };
  const monthValueEnd = block.dataset?.month;
  const monthValue = parseInt(monthMap[monthValueEnd], 10) - 1;
  const monthStart = blockStart.dataset?.monthStart;
  const monthValueStart = parseInt(monthMap[monthStart], 10) - 1;
  const progressBar = document.querySelector('[data-progress-bar]');
  if (!progressBar) {
    console.error("progress bar div not found");
    return;
  }
  const startDate = new Date(yearValueStart, monthValueStart, dayValueStart, minuteValueStart, hourValueStart).getTime();
  const endDate = new Date(yearValue, monthValue, dayValue, minuteValue, hourValue).getTime();
  if (!startDate) {
    console.error("startDate was missing [ countdown - timer ] ");
  }
  if (!endDate) {
    console.error("endDate was missing [ countdown - timer ] ");
  }
  let totalDistance = endDate - startDate;
  const calculatePercentage = setInterval(function () {
    const today = new Date().getTime();
    let percentage = (today - startDate) / totalDistance * 100;
    if (percentage >= 100) {
      percentage = 100;
      clearInterval(calculatePercentage);
    }
    if (percentage == 0) {
      percentage = 1;
    }
    progressBar.style.width = `${percentage}%`;
  }, 1000);
});

/***/ }),

/***/ "./js/sections/homepageBanner.js":
/*!***************************************!*\
  !*** ./js/sections/homepageBanner.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! gsap */ "./node_modules/gsap/index.js");
/* harmony import */ var gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! gsap/ScrollTrigger */ "./node_modules/gsap/ScrollTrigger.js");
/* harmony import */ var JsComponents_breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! JsComponents/breakpoints */ "./js/components/breakpoints.js");
/* harmony import */ var JsComponents_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! JsComponents/constants */ "./js/components/constants.js");




gsap__WEBPACK_IMPORTED_MODULE_0__["default"].registerPlugin(gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_1__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  const items = gsap__WEBPACK_IMPORTED_MODULE_0__["default"].utils.toArray('[data-video-parallax]');
  const currentBreakPoint = (0,JsComponents_breakpoints__WEBPACK_IMPORTED_MODULE_2__["default"])();
  items.forEach((item, index) => {
    const video = item.querySelector('[data-background-content]');
    // console.log(video.styles)
    let overlay = item.querySelector('[data-overlay]');
    let startingPoint = item.dataset.startingPoint || 10;
    let heightChange = currentBreakPoint >= JsComponents_constants__WEBPACK_IMPORTED_MODULE_3__.TABLET_BREAKPOINT ? 300 : 150;
    if (!overlay) {
      let calculatedStartingPoint = `${startingPoint - (index - 1) * 60}%`;
      const timeline = gsap__WEBPACK_IMPORTED_MODULE_0__["default"].timeline({
        scrollTrigger: {
          trigger: item,
          start: `${calculatedStartingPoint} center`,
          scrub: 1,
          ease: "none",
          markers: false
        }
      });
      timeline.add('start');
      timeline.fromTo(video, {
        "y": index == 1 ? `-200px` : `-${index * 200}px`
      }, {
        "y": `0`,
        duration: 3
      }, 'start');
    }
    if (overlay) {
      let calculatedStartingPoint = `${startingPoint - (index - 1) * 20}%`;
      gsap__WEBPACK_IMPORTED_MODULE_0__["default"].to(overlay, {
        "opacity": `0`,
        duration: 2,
        scrollTrigger: {
          trigger: item,
          start: 'bottom bottom',
          scrub: 0.75,
          ease: "none"
        }
      });
      gsap__WEBPACK_IMPORTED_MODULE_0__["default"].to(item, {
        "height": `${item.offsetHeight - heightChange}px`,
        duration: 3,
        scrollTrigger: {
          trigger: item,
          start: `${calculatedStartingPoint} center`,
          scrub: true,
          ease: "none",
          markers: false
        }
      });
    }
  });
  gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_1__["default"].config({
    // default is "resize,visibilitychange,DOMContentLoaded,load" so we can remove "resize" from the list:
    autoRefreshEvents: ""
  });
});

/***/ }),

/***/ "./js/sections/section.js":
/*!********************************!*\
  !*** ./js/sections/section.js ***!
  \********************************/
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _collectionBanner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./collectionBanner */ "./js/sections/collectionBanner.js");
/* harmony import */ var _homepageBanner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./homepageBanner */ "./js/sections/homepageBanner.js");
/* harmony import */ var _3d_scroll_wheel_animation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./3d-scroll-wheel-animation */ "./js/sections/3d-scroll-wheel-animation.js");
/* harmony import */ var _bundle_section__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./bundle-section */ "./js/sections/bundle-section.js");
/* harmony import */ var _countdown_timer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./countdown-timer */ "./js/sections/countdown-timer.js");





document.addEventListener('DOMContentLoaded', () => {
  (0,_3d_scroll_wheel_animation__WEBPACK_IMPORTED_MODULE_0__["default"])();
  (0,_collectionBanner__WEBPACK_IMPORTED_MODULE_1__["default"])();
  (0,_homepageBanner__WEBPACK_IMPORTED_MODULE_2__["default"])();
  (0,_bundle_section__WEBPACK_IMPORTED_MODULE_3__["default"])();
  (0,_countdown_timer__WEBPACK_IMPORTED_MODULE_4__["default"])();
});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"section": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors","shared"], () => (__webpack_require__("./js/sections/section.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;